import React from 'react'
import "./chatCard.css"
import MoreVertIcon from '@mui/icons-material/MoreVert';

function ChatCard({ Name, userName, Profile }) {
    return (
        <div className='CC-outerdiv'>
            <div className='CC-innerdiv'>
                <img src="images/45.png" className='CC-profile_image' />
            </div>
            <div className='CC-innerdiv'>
                <div className='CC-name1'>
                    <b>Ishita</b><br />
                    ishi
                </div>

                <MoreVertIcon className="more_icon" />
            </div>


        </div>
    )
}

export default ChatCard;